var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.30521 3.43146L3.36612 3.36612C3.83305 2.89919 4.57748 2.87888 5.06854 3.30521L5.13388 3.36612L12 10.2325L18.8661 3.36612C19.333 2.89919 20.0775 2.87888 20.5685 3.30521L20.6339 3.36612C21.1008 3.83305 21.1211 4.57748 20.6948 5.06854L20.6339 5.13388L13.7675 12L20.6339 18.8661C21.1008 19.333 21.1211 20.0775 20.6948 20.5685L20.6339 20.6339C20.167 21.1008 19.4225 21.1211 18.9315 20.6948L18.8661 20.6339L12 13.7675L5.13388 20.6339C4.66695 21.1008 3.92252 21.1211 3.43146 20.6948L3.36612 20.6339C2.89919 20.167 2.87888 19.4225 3.30521 18.9315L3.36612 18.8661L10.2325 12L3.36612 5.13388C2.89919 4.66695 2.87888 3.92252 3.30521 3.43146L3.36612 3.36612L3.30521 3.43146Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.86d4ce3b46a4d68507453c52e25c9011.svg";
export { ForwardRef as ReactComponent };